import {
  useGetAdminConnectivityMapProviders,
  usePostAdminConnectivityMapProviders
} from '@ijoin/hooks';
import { createFileRoute } from '@tanstack/react-router';

import { ConnectivityChecks } from '../../components';

const MapProvidersConnectivityPage = () => (
  <ConnectivityChecks
    label='MAP provider'
    linkIntegration={false}
    queryKey='/api/v3/admin/connectivity/map-providers'
    showHost
    showOrganizations={false}
    testId='mapProvidersConnectivity'
    useQuery={useGetAdminConnectivityMapProviders}
    useRefresh={usePostAdminConnectivityMapProviders}
  />
);

export const Route = createFileRoute('/connectivity/map-providers')({
  component: MapProvidersConnectivityPage
});
